"use client";
import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import TopBanner from "@/components/layout/TopBanner";
import Footer from "@/components/layout/Footer";
import { isChromelessPath } from "@/lib/routes";
// import ChatBot from "@/components/ChatBot/ChatBot";

export default function SiteChrome({ children }: { children: ReactNode }) {
  const pathname = usePathname();

  // Full-screen routes (quiz, feedback, login, organisme funnel, printable
  // programme) opt out of the shared chrome — see lib/routes.ts, which is also
  // what the breadcrumb system reads so the two can't drift apart.
  if (isChromelessPath(pathname)) {
    return <main className="min-h-screen overflow-x-hidden">{children}</main>;
  }

  return (
    <>
      <TopBanner />
      <main className="min-h-screen">{children}</main>
      <Footer />
      {/* <ChatBot /> */}
    </>
  );
}
